import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { routes } from './app.routes';
import { NgxsModule } from '@ngxs/store';
import { IServerModelState } from './secure/states/iserver-model.state';
import { NgxsEmitPluginModule } from '@ngxs-labs/emitter';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { FormlyModule } from '@ngx-formly/core';
import { MsalModule } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { IServerObjectTypeState } from './secure/states/iserver-objecttypes.state';
import { provideStore } from '@ngxs/store';
import { provideMarkdown } from 'ngx-markdown';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { AgentCoreConfigService } from './secure/services/agentcore-config.service';

export function initializeApp(agentCoreConfigService: AgentCoreConfigService) {
  return () => firstValueFrom(agentCoreConfigService.loadConfig());
}

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.applicationClientId,
    authority: environment.authority,
    redirectUri: environment.redirectUri,
    postLogoutRedirectUri: environment.redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      piiLoggingEnabled: false,
      logLevel: LogLevel.Info
    }
  }
});

export function loggerCallback(message: string) {
  console.log(message);
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideMarkdown(),
    provideStore([IServerModelState, IServerObjectTypeState]),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Enable FetchBackend by calling withFetch()
    provideHttpClient(
      withFetch(), // Enable Fetch API
      withInterceptorsFromDi() // Enable DI-based interceptors
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AgentCoreConfigService],
      multi: true
    },
    provideNativeDateAdapter(),
    importProvidersFrom(
      NgxsModule.forRoot([IServerModelState, IServerObjectTypeState], { developmentMode: true }),
      NgxsLoggerPluginModule.forRoot({ disabled: true }),
      NgxsEmitPluginModule.forRoot(),
      FormlyModule.forRoot(),
      MsalModule.forRoot(
        msalInstance,
        {
          interactionType: InteractionType.Redirect,
          loginFailedRoute: '/public/login-failed',
          authRequest: {
            scopes: ['https://draexlmaier.iserver365.com/user_impersonation'],
          },
        },
        {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map<string, Array<string>>([
            [environment.iServerUrl, ['https://draexlmaier.iserver365.com/user_impersonation']]
          ])
        }
      )
    ),
  ]
};